exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-input-wrapper .right-icon[data-v-7cdd9ad9]{position:absolute;top:50%;right:15px;transform:translateY(-50%);cursor:pointer;fill:var(--black-light-5)}", ""]);

// exports
